<template>
    <div>
    <Modal
        class-name="vertical-center-modal"
        :value="showSetModel && (DataType==1 || DataType==7 || DataType==14 || DataType==15 || DataType==16)"
        :title="$t('edit')"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'min-width':'600px'}">


        <div v-if='DataType==16' style="margin-bottom:16px">
            <RadioGroup  v-model="cssType"  @on-change="changeType">
                <Radio label="type1"></Radio>
                <Radio label="type2"></Radio>
            </RadioGroup>
        </div>


        <!-- <RadioGroup v-model="formData.elementType" @on-change="setElementTypeVal($event)">
            <Radio v-for="item in elementTypeList" :label="item.id+''" :key="item.id">{{ item.val }}</Radio>
        </RadioGroup> -->
        
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80" >

            <div v-show="DataType==16 && cssType=='type2'">
                <FormItem :label="$t('BasicProduct.funcBox.titleName.time')" prop="time" :rules="(DataType==16 && cssType=='type2') ? ruleCustom['time']: ruleCustom.noRequired" style="width: 500px">
                    <Select :placeholder="$t('selectPlaceholder')"  class="input-div" v-model="formData.time">
                        <Option v-for="item in timeList2" :value="item.id+''" :key="item.id" @click.native="formData.label=item.val">{{item.val}}</Option>
                    </Select>
                </FormItem>
    
                <FormItem :label="$t('BasicProduct.funcBox.titleName.timeFormate')" prop="formate" :rules="(DataType==16 && cssType=='type2') ? ruleCustom['formate']: ruleCustom.noRequired" style="width: 500px">
                    <Select :placeholder="$t('selectPlaceholder')"  class="input-div" v-model="formData.formate">
                        <Option v-for="item in timeFormateList" :value="item.id+''" :key="item.id">{{item.val}}</Option>
                    </Select>
                </FormItem>
    
    
                 <FormItem :label="$t('BasicProduct.funcBox.titleName.Max')" prop="max" :rules="(DataType==16 && cssType=='type2') ? ruleCustom['max']: ruleCustom.noRequired" style="width: 500px" >
                     <Input type="text"  v-model.trim="formData.max"  :placeholder="$t(`inputPlaceholder`)"></Input>
                </FormItem>
    
                 <FormItem :label="$t('BasicProduct.funcBox.titleName.Min')" prop="min" :rules="(DataType==16 && cssType=='type2') ? ruleCustom['min']: ruleCustom.noRequired" style="width: 500px" >
                   <Input type="text"  v-model.trim="formData.min"  :placeholder="$t(`inputPlaceholder`)"></Input>
                </FormItem>
            </div>
            <div v-show="cssType=='type1'">

                <FormItem :label="$t('BasicProduct.funcBox.titleName.Min')" class="ivu-form-item-required" prop="Min" :rules="(cssType=='type1') ? ruleCustom['Min']: ruleCustom.noRequired" style="width: 500px">
                   
                   <Input type="number" v-model="formData.Min" :placeholder="$t('inputPlaceholder')" ></Input>
               </FormItem>
    
    
               <FormItem :label="$t('BasicProduct.funcBox.titleName.Max')" class="ivu-form-item-required" prop="Max" :rules="(cssType=='type1') ? ruleCustom['Max']: ruleCustom.noRequired" style="width: 500px">
                   <Input type="number" v-model="formData.Max" :placeholder="$t('inputPlaceholder')"></Input>
               </FormItem>
    
              
               
               <FormItem :label="$t('BasicProduct.funcBox.titleName.Decimals')" prop="Decimals" :rules="(cssType=='type1') ? ruleCustom['Decimals']: ruleCustom.noRequired" style="width: 500px">
                   <Input type="number" v-model="formData.Decimals" :placeholder="$t('inputPlaceholder')"></Input>
               </FormItem>
               
               <FormItem :label="$t('BasicProduct.funcBox.titleName.Step')"  class="ivu-form-item-required" prop="Step" :rules="(cssType=='type1') ? ruleCustom['Step']: ruleCustom.noRequired" style="width: 500px">
                   <Input type="number" v-model="formData.Step" :placeholder="$t('inputPlaceholder')"></Input>
               </FormItem>
               
               <FormItem v-if="DataType==7 || DataType==14" :label="$t('BasicProduct.funcBox.titleName.Multiple')" prop="Multiple" :rules="(cssType=='type1') ? ruleCustom['Multiple']: ruleCustom.noRequired" style="width: 500px">
                   <Input type="number" v-model="formData.Multiple" :placeholder="$t('inputPlaceholder')"></Input>
               </FormItem>
               
    
               <FormItem :label="$t('BasicProduct.funcBox.titleName.Unit')"  prop="LanguageKey"  class="" style="width: 500px">

                   <div v-if="isGener && !hasWord" class="ivu-input">{{ formData.LanguageKey }} {{ local=='zh-CN'?formData['Unit-CN']:formData['Unit-EN'] }}</div>
                   
                   <template v-else>
                        <SearchSelectPage  refName="select" listName="dealersList"  :showPage="true" ref="select" :selectUrlQuery="{pageId:pageID}" :url="pagesIdListUrl"  labelName='wordCode'  isMultiple='2'  valName='id' :labelNameNew="local=='zh-CN'?'simpleChinese':'englishText'" keyword="wordCode" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectValPage($event)"></SearchSelectPage>
                    </template>
                  
               </FormItem>

            </div>    



            
            
             <FormItem v-if="isGener">
                <Button type="primary" @click="cancel">{{$t("cancel")}}</Button>
            </FormItem>

            <FormItem v-else>
                <Button type="primary"  :disabled="type==3" @click="handleSubmit('formData')">{{$t('save')}}</Button>
                <Button @click="cancel" style="margin-left: 8px">{{$t('cancel')}}</Button>
            </FormItem>
        </Form>

    </Modal>
    </div>
</template>
<script>
/**
 * 弹框
 * @param showSetModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
// import SearchSelectPage from '@/views/common/selectListPage.vue';  //20220415
import SearchSelectPage from '@/views/common/selectListRecycle.vue';  //20220415

import { mapState } from 'vuex'

    export default {
        props: {
            showSetModel: Boolean,
            fn:Function,
            type:Number,
            pageId:[Number, String],
            editFormData:Object,
            DataType:String,
            keyType:String,
            // languageKey:Object,
            // initdata:Object,
            isGener:{
                type:Boolean,
                default:false
            }
        },
        name: "ModelNumberType",
        components:{
            SearchSelectPage
        },
        data() {
            return {   
                pagesIdListUrl: this.config.urlArray.pagesLangDictionaryList,//对应pageId的词条列表
                disabled: false,//禁用确定按钮
                formData: {
                   Max:"",
                   Min:"",
                   Decimals:"",
                   Step:"",
                   Multiple:"",
                //    Negative:"",
                   'Unit-CN':"",
                   'Unit-EN':"",
                   LanguageKey:"",
                   wordId:"",
                    "pageId_wordCode":"",

                   time:'',
                   label:'',
                   max:'',
                   min:'',
                   formate:''
                },
                wordListLoading:false,
                wordList:[],
                hasWord:false,
                cssType:'type1',
                pageID:'',
                needWordcode:false,
                timeFormateList:[
                    {id: 'YYYY-MM-DD',val:"YYYY-MM-DD"},
                    {id: 'YYYY-MM-DD HH-MM-SS',val:"YYYY-MM-DD HH-MM-SS"},
                    {id: 'HH-MM-SS',val:"HH-MM-SS"},
                    {id: 'HH-MM',val:"HH-MM"},
                    {id: 'MM-SS',val:"MM-SS"},
                    {id: 'MM-SS-MS',val:"MM-SS-MS"},
                    {id: 'SS-MS',val:"SS-MS"},
                ]
               
            }
        },
        computed:{
            ...mapState(['local','selectId','wordListAll','wordListByPageId','pageIdStore']),
             ruleCustom(){
                 return {//验证
                    Max: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                        {validator: this.validateValue,trigger: 'blur' }
                    ],
                    Min: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                        {validator: this.validateValueMin,trigger: 'blur' }
                    ],
                    Decimals: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    Step: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                        {validator: this.validateStep,trigger: 'blur' }
                    ],
                    Multiple: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
         
                    // LanguageKey: [
                    //     {required: true, message: this.$t('required'),trigger: 'change' },
                    // ],
                    time: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    formate: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    max: [
                        {required: false, message: this.$t('required'),trigger: 'blur' },
                    ],
                    min: [
                        {required: false, message: this.$t('required'),trigger: 'blur' },
                    ],
                    noRequired: [{ required: false }]
                }
             } ,
             timeList2(){
                return [
                    {id: '1',val:this.$t('selectList.timeUnit.msceond')},
                    {id: '2',val:this.$t('selectList.timeUnit.second')},
                    {id: '3',val:this.$t('selectList.timeUnit.minute')},
                    {id: '4',val:this.$t('selectList.timeUnit.hour')},
                ]
            },

        },
        created(){
            this.pageID = this.pageId || this.pageIdStore || ''
           
        },
        methods: {
            changeType(e){
               console.log('e',e)
            },
            setSelectValPage(selItem){
                if(selItem){
                    this.formData['wordId'] = selItem.id+'';
                    this.formData['LanguageKey'] = selItem.wordCode;
                    this.formData['pageId_wordCode'] = this.pageID+'_'+selItem.wordCode+'';
                    this.formData['Unit-CN'] = selItem.simpleChinese;
                    this.formData['Unit-EN']= selItem.englishText

                    console.log(' this.formData this.formData this.formData', this.formData)
                }else{
                    this.clearSelectVal()
                }
            },
            
            clearSelectVal(){
                this.formData['wordId'] = '';
                this.formData['LanguageKey'] = '';
                this.formData['pageId_wordCode'] = '';
                this.formData['Unit-CN'] = '';
                this.formData['Unit-EN']= ''

            },
            validateValueMin(rule, value, callback){
                if (value === '') {
                    callback(new Error(this.$t('required')));
                } else {

                    if( (this.formData.Max !=='')){
                        this.$refs.formData.validateField('Max');
                    }
                    callback();
                }

            },
            validateValue(rule, value, callback){
                // console.log('value',value)
                // console.log('this.formData.Min1',this.formData.Min)
                if (value === '') {
                    callback(new Error(this.$t('required')));
                } else {

                    if(this.formData.Min === ''){
                        callback();
                    }else if(value*1 <= this.formData.Min*1){
                        // console.log('this.formData.Min',this.formData.Min)
                        callback(new Error('最大值必须大于最小值'));
                    }else{
                        // console.log('this.formData.Decimals',this.formData.Decimals)
                        if(this.formData.Min !== '' && this.formData.Decimals !== ''){

                            this.$refs.formData.validateField('Step');
                        }
                        callback();
                    }
                }
               
            },
            validateStep(rule, value, callback){
                if (value === '') {
                    callback(new Error(this.$t('required')));
                } else {

                    if(this.formData.Min === '' || this.formData.Max === ''){
                        callback();
                    }else if(value*1> (this.formData.Max*1-this.formData.Min*1)){
                        callback(new Error('步长不能大于取值范围的差值'));
                    }else{
                        callback();
                    }
                }
            },
            handleSubmit (name) {
                if(this.isGener){
                    return
                }
             
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        
                        //如果不带hex 删除下面两个属性
                        if(this.DataType==1){
                           delete this.formData.Multiple
                        //    delete this.formData.Negative
                        }

                        //遍历数据，如果是新增，key重复则提示
                        // if(this.type==1){

                        //     let arr = this.editFormData.allArr
                        //     if(arr){
                        //         for(let i = 0;i< arr.length;i++){
                        //             if(arr[i].LanguageKey==this.formData.LanguageKey){
                        //                this.$Message.error('LanguageKey重复')
                        //                return
                        //             }
                        //         }
                               
                        //     }
                        // }

                        let params = {
                            ...this.formData
                        }

                        if(this.cssType == 'type1'){
                            delete params.time
                            delete params.label
                            delete params.max
                            delete params.min
                            delete params.formate
                        }else{
                            delete params.Max
                            delete params.Min
                            delete params.Decimals
                            delete params.Step
                            delete params.Multiple
                            delete params['Unit-CN']
                            delete params['Unit-EN']
                            delete params.LanguageKey
                            delete params.wordId
                            delete params.pageId_wordCode
                        }

                       this.fn({...params},this.DataType)
                       setTimeout(()=>{
                           this.resetForm()
                       },0)
                    } else {
                        this.$Message.error('Fail!');
                    }
                })
            },
          
            async openOrClose(value) {
                if(value === true) {
                    if(this.type==1 && this.$refs.select){
                        this.$refs.select.getData()
                    }

                    if(this.type==2){
                        this.formData=  {...this.editFormData.IndentyName}
                     
                        if(this.$refs.select){
                            this.$refs.select.setDefVal({
                              id:this.formData.wordId,
                              wordCode: this.formData.LanguageKey
                            })
                        }
                        

                        if(this.formData.time){
                            this.cssType = 'type2'
                        }
                       
                    }
                } 
            },
            cancel() {//对话框关闭
                this.$emit('update:showSetModel',false);
                this.resetForm()
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                if(this.$refs.select){
                    this.$refs.select.clearVal() 
                }
                Object.keys(this.formData).forEach(key=>{this.formData[key]=''})
                this.disabled = false;//恢复提交按钮为激活状态'
                this.hasWord = false
                this.cssType = 'type1'
                this.needWordcode = false
            }
        }
    }
</script>

<style lang="less" scoped>
/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;

        .ivu-select-dropdown {
            max-width: 380px;
        }
    }

   
}
/deep/ .ivu-input-number{
    width: 100% !important;
}
/deep/ .ivu-input[disabled]{
    background-color: #ffffff;
    color: #515a6e;
}

</style>

